export default "__VITE_ASSET__DJEF6KX9__"